import React from 'react';
import Layout from '../../components/Layout';
import UserHeader from '../../components/header/User';
import AccountContent from '../../components/content/Account';
import Sponsor from '../../components/Sponsor';
import User from '../../domain/User';
import t from 'tcomb-form';
import { props } from 'tcomb-react';

@props({
  districts: t.Arr,
  loadDistricts: t.Func,
  doUpdateAccount: t.Func,
  locale: t.Obj,
  user: User,
  doAcceptCookies: t.Func,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  message: t.maybe(t.ReactElement)
})
export default class Account extends React.Component {

  getHeader() {
    return (
      <UserHeader
        user={this.props.user}
        locale={this.props.locale}
        goAccount={this.props.goAccount}
        goChangePassword={this.props.goChangePassword}
        goPurchases={this.props.goPurchases}
        doLogout={this.props.doLogout} />
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }

  render() {
    const { locale } = this.props;
    return (
      <Layout header={this.getHeader()} sponsor={this.getSponsor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <AccountContent
          districts={this.props.districts}
          loadDistricts={this.props.loadDistricts}
          doUpdateAccount={this.props.doUpdateAccount}
          locale={this.props.locale}
          user={this.props.user}
          doAcceptCookies={this.props.doAcceptCookies}
          goAccount={this.props.goAccount}
          goChangePassword={this.props.goChangePassword}
          goPurchases={this.props.goPurchases}
          doLogout={this.props.doLogout}
          message={this.props.message} />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/Account.js
 **/